import BaseStore from '@src/utils/store/base-store';

class FifthPageStore extends BaseStore {
  use() {}
}
export default FifthPageStore;
